import { render, staticRenderFns } from "./business-license.vue?vue&type=template&id=6aee2d7c&scoped=true"
import script from "./business-license.vue?vue&type=script&lang=js"
export * from "./business-license.vue?vue&type=script&lang=js"
import style0 from "./business-license.vue?vue&type=style&index=0&id=6aee2d7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aee2d7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/.jenkins/workspace/web-douhua-mcn-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aee2d7c')) {
      api.createRecord('6aee2d7c', component.options)
    } else {
      api.reload('6aee2d7c', component.options)
    }
    module.hot.accept("./business-license.vue?vue&type=template&id=6aee2d7c&scoped=true", function () {
      api.rerender('6aee2d7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apply/components/business-license.vue"
export default component.exports